var map = {
	"./cabinet_t4.png": "aT2z",
	"./closure_t4.png": "IHCr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t5Mx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons ^\.\/.*_t4\.png$
// module id = t5Mx
// module chunks = 0